var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "in",
    transform: "translate(-135.807 -1012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    transform: "translate(135.807 1012)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "linkedin",
    d: "M0,6.394a1.305,1.305,0,0,1,.424-1A1.556,1.556,0,0,1,1.527,5a1.51,1.51,0,0,1,1.079.388A1.367,1.367,0,0,1,3.03,6.43a1.276,1.276,0,0,1-.412.97A1.559,1.559,0,0,1,1.5,7.8H1.491A1.483,1.483,0,0,1,.412,7.4,1.343,1.343,0,0,1,0,6.394ZM.158,17V8.9H2.848V17Zm4.182,0H7.03V12.479a1.578,1.578,0,0,1,.612-1.352,1.317,1.317,0,0,1,.867-.285q1.358,0,1.358,1.83V17h2.691V12.358a3.9,3.9,0,0,0-.848-2.721,2.894,2.894,0,0,0-2.242-.927A2.751,2.751,0,0,0,7.03,10.055v.024H7.018l.012-.024V8.9H4.339q.024.388.024,2.412T4.339,17Z",
    transform: "translate(144.528 1015.643)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/in.00ba6275f59847bc82df687879b628a7.svg";
export { ForwardRef as ReactComponent };